// Lightweight analytics: fires GA4 events if gtag is present, else no-op.
// This makes form + booking conversions measurable once GA4 is installed.
export const track = (event, params = {}) => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", event, params);
    }
    if (typeof window !== "undefined" && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event, ...params });
    }
  } catch {
    // analytics is best-effort; never let tracking break the UI
  }
};

// Google Ads conversion — fires only when explicitly called (after a confirmed
// successful lead submission). Safe no-op if gtag is unavailable. No PII.
export const trackLeadConversion = () => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "ads_conversion_Submit_lead_form_1", {});
    }
  } catch {
    // analytics is best-effort; never let tracking break the UI
  }
};
